import { Box } from '@optiaxiom/react';
import { createColumnHelper } from '@tanstack/react-table';

import { SpecializedAgentExecution } from '@frontend/types/specialized-agent';

import {
  ActionsCell,
  EvaluationScoreCell,
  ExecutionTimeCell,
  ParametersCell,
  StatusCell,
  TimeStampCell,
} from './cells';

const columnHelper = createColumnHelper<SpecializedAgentExecution>();

type TableMeta = {
  onRowClick?: (execution: SpecializedAgentExecution) => void;
  selectedExecutionId?: string | null;
};

const createColumns = ({ baselineEvaluationScore }: { baselineEvaluationScore?: number }) => [
  columnHelper.accessor('created_at', {
    id: 'timestamp',
    header: 'Timestamp',
    size: 190,
    cell: ({ row, table }) => {
      const meta = table.options.meta as TableMeta;
      const status = row.original.status.toLowerCase();
      const isSelected = meta?.selectedExecutionId === row.original.id;
      return (
        <Box
          onClick={() => meta?.onRowClick?.(row.original)}
          cursor="pointer"
          w="full"
          data-status={status}
          data-selected={isSelected}
        >
          <TimeStampCell timestamp={row.original.created_at} />
        </Box>
      );
    },
  }),
  columnHelper.display({
    id: 'parameters',
    header: 'Parameters',
    size: 550,
    cell: ({ row, table }) => {
      const meta = table.options.meta as TableMeta;
      return (
        <Box onClick={() => meta?.onRowClick?.(row.original)} cursor="pointer" w="full">
          <ParametersCell parameters={row.original.parameters} />
        </Box>
      );
    },
  }),
  columnHelper.display({
    id: 'evaluation_score',
    header: 'Evaluation Score',
    cell: ({ row, table }) => {
      const meta = table.options.meta as TableMeta;
      return (
        <Box onClick={() => meta?.onRowClick?.(row.original)} cursor="pointer" w="full">
          <EvaluationScoreCell
            evaluationScore={row.original.evaluation_score}
            baselineEvaluationScore={baselineEvaluationScore}
          />
        </Box>
      );
    },
  }),
  columnHelper.display({
    id: 'execution_time',
    header: 'Execution Time',
    cell: ({ row, table }) => {
      const meta = table.options.meta as TableMeta;
      return (
        <Box onClick={() => meta?.onRowClick?.(row.original)} cursor="pointer" w="full">
          <ExecutionTimeCell time={row.original.execution_time} />
        </Box>
      );
    },
  }),
  columnHelper.accessor('status', {
    id: 'status',
    header: 'Status',
    cell: ({ row, table }) => {
      const meta = table.options.meta as TableMeta;
      return (
        <Box onClick={() => meta?.onRowClick?.(row.original)} cursor="pointer" w="full">
          <StatusCell status={row.original.status} />
        </Box>
      );
    },
  }),
  columnHelper.display({
    id: 'actions',
    header: 'Actions',
    size: 80,
    enableResizing: false,
    cell: ({ row }) => {
      return <ActionsCell execution={row.original} />;
    },
  }),
];

export default createColumns;
